import React from 'react';
import styled from 'styled-components';
import { SideBar } from '../../nav-bar';
import { Map } from '../../maps';
import { SidePanel } from './side-panel';
import { BottomPanel } from './bottom-panel';
import { signOut } from '../../auth';
import { AppHeader } from './header';
import { SnackbarAlert } from './snackbar';

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
`;
const Row = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  overflow: hidden;
`;

export const Main = () => (
  <MainContainer>
    <SnackbarAlert />
    <AppHeader signOut={signOut} />
    <SideBar />
    <Row>
      <Map />
      <SidePanel />
    </Row>
    <BottomPanel />
  </MainContainer>
);
